<template>
  <div>
    <div class="page-title">New Chat Box</div>
    <Form v-if="form" v-model="form" :submit="create" btnText="Add Chatbox" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.chats.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.Chat.new();
      this.form = data;
    },
    async create() {
      await this.$api.Chat.create(this.form);
      this.$router.push("/chats");
    },
  },
};
</script>

<style></style>
